import { dual } from 'effect/Function';
export const create = (iterable) => new Set(iterable);
// Set.prototype.
export const copy = (set) => new Set(set);
export const has = dual(2, (self, value) => self.has(value));
export const hasOnly = dual(2, (self, value) => self.size === 1 && self.has(value));
export const is = (value) => value instanceof globalThis.Set;
export const add = dual(2, (self, value) => {
    if (self.has(value)) {
        return self;
    }
    const result = copy(self);
    result.add(value);
    return result;
});
export const values = (set) => set.values();
export const remove = dual(2, (self, value) => {
    if (!self.has(value)) {
        return self;
    }
    const result = copy(self);
    result.delete(value);
    return result;
});
export const equals = (first, second) => {
    if (first.size !== second.size) {
        return false;
    }
    for (const item of first) {
        if (!second.has(item)) {
            return false;
        }
    }
    return true;
};
export const size = (set) => set.size;
export const toggle = dual(2, (self, value) => {
    if (has(self, value)) {
        return remove(self, value);
    }
    return add(self, value);
});
/**
 * Returns a new set containing items from `self` that are not present in `other`.
 *
 * @example
 * difference(new Set([1, 2, 3]), new Set([2, 3, 4])) // Set(1) { 1 }
 * pipe(new Set([1, 2, 3]), difference(new Set([2, 3, 4]))) // Set(1) { 1 }
 */
export const difference = dual(2, (self, other) => {
    const result = create();
    for (const item of self) {
        if (!other.has(item)) {
            result.add(item);
        }
    }
    return result.size === self.size ? self : result;
});
/**
 * Returns a new set containing items present in both `self` and `other`.
 *
 * @example
 * intersect(new Set([1, 2, 3]), new Set([2, 3, 4])) // Set(2) { 2, 3 }
 * pipe(new Set([1, 2, 3]), intersect(new Set([2, 3, 4]))) // Set(2) { 2, 3 }
 */
export const intersect = dual(2, (self, other) => {
    const result = create();
    for (const item of self) {
        if (other.has(item)) {
            result.add(item);
        }
    }
    return result.size === self.size ? self : result;
});
/**
 * Returns a new set containing all items from both `self` and `other`.
 *
 * @example
 * union(new Set([1, 2, 3]), new Set([2, 3, 4])) // Set(4) { 1, 2, 3, 4 }
 * pipe(new Set([1, 2, 3]), union(new Set([2, 3, 4]))) // Set(4) { 1, 2, 3, 4 }
 */
export const union = dual(2, (self, other) => {
    const result = create([...self, ...other]);
    return result.size === self.size ? self : result;
});
//# sourceMappingURL=Set.js.map